import { z } from 'zod';

/**
 * The client can select a family, but all pack identity and source lineage are
 * derived from the persisted V3 document by the server-side retry service.
 */
export const ProceduralReviewRetryRequestSchema = z.object({
  family_id: z.string().min(2).max(120),
}).strict();
export type ProceduralReviewRetryRequest = z.infer<
  typeof ProceduralReviewRetryRequestSchema
>;

export const ProceduralReviewRetryResponseSchema = z.object({
  document_id: z.string().uuid(),
  document_version: z.number().int().positive(),
  family_id: z.string().min(2).max(120),
  analysis_completeness: z.enum(['complete', 'partial']),
}).strict();
export type ProceduralReviewRetryResponse = z.infer<
  typeof ProceduralReviewRetryResponseSchema
>;
